/**
 * NZSC-3178 — 매매리포트 실시간 대출 상담 채팅(loan-relay 연동) 진입점 2단계 토글.
 *
 * sherlockSubscriptionAccessHelpers 와 동일 패턴.
 * 진입점: LoanReport 플로팅 버튼 / LoanStrategyInfo CTA 3곳.
 *
 * 우선순위:
 *   FEATURE_FLAG_ENABLED === true                                 → 전체 오픈(2차) → 신 실시간 채팅
 *   INTERNAL_TESTER_ENABLED === true && isInternalTester === true  → 내부 테스터 한정(1차) → 신 채팅
 *   그 외                                                            → 기존 폴링 문의챗(/loan/consult/chat) 유지
 *
 * 단계:
 *   1차 prod: FEATURE_FLAG_ENABLED=false + INTERNAL_TESTER_ENABLED=true (테스터만 신 채팅, 나머지 기존)
 *   2차 오픈: FEATURE_FLAG_ENABLED=true
 */
export function fnCreateLoanRelayChatAccessChecker(featureFlagEnabled, internalTesterEnabled) {
  return function fnIsLoanRelayChatEnabled(isInternalTester) {
    if (featureFlagEnabled === true) return true;
    if (internalTesterEnabled && isInternalTester === true) return true;
    return false;
  };
}

// 운영 상수 — 1차 배포: 테스터만
const FEATURE_FLAG_ENABLED = true; // NZSC-3178 매매리포트 대출상담 풀오픈(2026-06-29). 전세 퍼널은 별도 게이트(미오픈).
const INTERNAL_TESTER_ENABLED = true;

export const fnIsLoanRelayChatEnabled = fnCreateLoanRelayChatAccessChecker(
  FEATURE_FLAG_ENABLED,
  INTERNAL_TESTER_ENABLED,
);

// NZSC-3220 — 전세 퍼널 전용 게이트(매매 풀오픈과 독립).
// 2026-07-02 전세 풀오픈(오너 신호 + 테스터 QA 통과). 롤백 = 이 플래그만 false.
const JEONSE_FEATURE_FLAG_ENABLED = true;
export const fnIsJeonseLoanRelayEnabled = fnCreateLoanRelayChatAccessChecker(
  JEONSE_FEATURE_FLAG_ENABLED,
  INTERNAL_TESTER_ENABLED,
);

// 진입점 공통: 테스터면 신 실시간 채팅, 아니면 기존 폴링 문의챗 경로
// reportSeq 를 쿼리로 실어야 새로고침/재진입 시 해당 리포트 상담을 복원할 수 있다.
// channel='jeonse' 이면 전세 채팅 모드(타이틀/봇이름/인트로/칩 스왑)로 진입한다.
//   매매 호출부는 channel 을 넘기지 않으므로 기존 동작과 100% 동일(쿼리에 channel 미포함).
export function loanChatRoute(isInternalTester, reportSeq = null, channel = null) {
  if (!fnIsLoanRelayChatEnabled(isInternalTester)) return "/loan/consult/chat";
  const query = {};
  if (reportSeq != null && reportSeq !== "") query.reportSeq = String(reportSeq);
  if (channel === "jeonse") query.channel = "jeonse";
  return Object.keys(query).length ? { path: "/loan/relay-chat", query } : "/loan/relay-chat";
}
